<template>
  <section>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <span class="text-primary">Newsletter </span>
          <b-breadcrumb class="ml-2">
            <b-breadcrumb-item>
              <feather-icon
                icon="HomeIcon"
                scale="1.25"
                shift-v="1.25"
              ></feather-icon>
            </b-breadcrumb-item>
            <b-breadcrumb-item active> Statistiche</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </template>


    <div class="mt-2">
        In allestimento
    </div>



    </b-card>
  </section>
</template>

<script>

import FullCalendar from '@fullcalendar/vue';
import { BBreadcrumb, BBreadcrumbItem, BCard } from "bootstrap-vue";

export default {
  components: {
    FullCalendar,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
  },
}

</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>

